<template>
	<div class="info-content">
		<el-form label-width="80px">
			<el-form-item label="外边距">
				<el-input-number v-model="list.marginTop" placeholder="单位像素（px）" controls-position="right" :step="2" step-strictly></el-input-number>
			</el-form-item>
			<el-form-item label="内边距">
				<el-input-number v-model="list.paddingTop" placeholder="单位像素（px）" controls-position="right" :step="2" step-strictly></el-input-number>
			</el-form-item>
			<el-form-item label="左边距">
				<el-input-number v-model="list.paddingLeft" placeholder="单位'%'" controls-position="right" :step="1" step-strictly></el-input-number>
			</el-form-item>
			<el-form-item label="右边距">
				<el-input-number v-model="list.paddingRight" placeholder="单位'%'" controls-position="right" :step="1" step-strictly></el-input-number>
			</el-form-item>
			<el-form-item label="跳转图片">
				<el-upload
					class="avatar-uploader"
					:action="'https://app.kcguoyi.com/api/service/upload/uploadImage'"
					:auto-upload="false"
					:show-file-list="false"
					:on-change="handleImport"
					accept="image/gif,image/jpeg,image/jpg,image/png"
					drag
				>
					<img v-if="data.data.length > 0" :src="data.data[0]" class="avatar" />
					<i v-else class="el-icon-upload"></i>
					<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
				</el-upload>
			</el-form-item>
			<el-form-item label="固定底部">
				<el-select filterable v-model="data.bookLink_fixed" value-key="lable" style="width: 100%">
					<el-option :label="optItem.dictLabel" :value="optItem.dictValue" v-for="(optItem, index) in bookLink_fixedData" :key="index + 'option_selected'"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="跳转地址">
				<el-select filterable v-model="data.targetAddress" value-key="lable" style="width: 100%" @change="targetBookIsShow">
					<el-option :label="optItem.dictLabel" :value="optItem.dictValue" v-for="(optItem, index) in targetAddressData" :key="index + 'option_selected'"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="跳转书籍" v-if="targetBookToggle">
				<el-select filterable v-model="data.targetBook" value-key="lable" style="width: 100%">
					<el-option :label="optItem.dictLabel" :value="optItem.dictValue" v-for="(optItem, index) in targetBookData" :key="index + 'option_selected'"></el-option>
				</el-select>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
// 上传图片
import axios from 'axios';
export default {
	name: 'bookLink',
	props: ['data'],
	data() {
		return {
			list: {},
			bookLink_fixedData: [
				{ dictLabel: '否', dictValue: '' },
				{ dictLabel: '是', dictValue: 'bookLink_fixed' },
			],
			targetAddressData: [
				{ dictLabel: '书架', dictValue: '1' },
				{ dictLabel: '书籍落地页', dictValue: '2' },
				{ dictLabel: '课程落地页', dictValue: '3' },
				{ dictLabel: '书籍', dictValue: '4' },
			],
			targetBookData: [],
			targetAddressToggle: true,
			targetBookToggle: false,
		};
	},
	mounted() {
		this.list = this.data;
		if (this.data.targetAddress && this.data.targetAddress != 1) {
			this.targetBookToggle = true;
		}
		if (this.data.aiId && this.data.aiId != '' && this.data.aiId != 'null') {
			this.getBookTableData(this.data.aiId);
		}
	},
	methods: {
		getBookTableData(aiId) {
			var url = process.env.VUE_APP_BASE_API + '/act/book/listH5?aiId=' + aiId + '';
			axios.get(url, { headers: { Authorization: 'Bearer ' + this.data.token, clientOs: 'h5' } }).then((res) => {
				if (res.data.rows.length <= 0) {
					this.targetAddressToggle = false;
					return false;
				}
				var newArray = res.data.rows;
				this.targetBookData = [];
				newArray.map((e) => {
					if (e.bookStatusCode == 'YX') {
						this.targetBookData.push({ dictLabel: e.bookName, dictValue: e.abId });
					}
				});
			});
		},
		//图片上传
		handleImport(file, fileList) {
			if (fileList.length > 1) {
				fileList.splice(0, 1);
			}
			const params = new FormData();
			params.append('file', file.raw);
			var loading = this.$loading({
				lock: true,
				text: '图片上传中',
			});
			var url = 'https://app.kcguoyi.com/api/service/upload/uploadImage';
			axios
				.post(url, params, {
					headers: { 'Content-Type': 'multipart/form-data' },
				})
				.then((res) => {
					this.list.data.push(res.data.body[0].url);
				})
				.finally(() => {
					this.$nextTick(() => {
						this.$forceUpdate();
					});
					loading.close();
				});
		},
		//书籍信息是否显示隐藏
		targetBookIsShow(type) {
			if (type != 1) {
				this.targetBookToggle = true;
			} else {
				delete this.data.targetBook;
				this.targetBookToggle = false;
			}
		},
	},
};
</script>

<style scoped>
.info-content {
	padding: 20px;
}
.el-input-number {
	width: 220px;
}
div /deep/ .el-upload-dragger {
	width: 220px;
	height: 140px;
}
div /deep/ .el-upload-dragger .el-icon-upload {
	margin-top: 20px;
}

.avatar {
	width: 220px;
	height: 140px;
	display: block;
}
</style>